import { HoldingClass, Partner, TradingOffer } from 'types';

export enum TradingOfferOperationStatus {
  PENDING = 'PENDING', // eslint-disable-line no-unused-vars
  KYC_REVIEW = 'KYC_REVIEW', // eslint-disable-line no-unused-vars
  VALIDATION = 'VALIDATION', // eslint-disable-line no-unused-vars
  PAYMENT_PENDING = 'PAYMENT_PENDING', // eslint-disable-line no-unused-vars
  TRANSFER_PENDING = 'TRANSFER_PENDING', // eslint-disable-line no-unused-vars
  COMPLETED = 'COMPLETED', // eslint-disable-line no-unused-vars
  CANCELLED = 'CANCELLED', // eslint-disable-line no-unused-vars
  REJECTED = 'REJECTED', // eslint-disable-line no-unused-vars
}

export type TradingOfferOperationCommentRole = 'BUYER' | 'SELLER' | 'ADMIN';

export type TradingOfferOperationComment = {
  _id: string;
  user: string | { _id?: string; name?: string; email?: string };
  role?: TradingOfferOperationCommentRole;
  text: string;
  createdAt: Date | string;
  updatedAt: Date | string;
};

export type TradingOfferOperationStatusHistory = {
  status: TradingOfferOperationStatus;
  date: Date | string;
  user?: string;
  comment?: string;
};

export type TradingOfferDocumentRequestType = 'ID' | 'PAYMENT_PROOF' | 'OTHER';

export type TradingOfferOperationDocumentRequest = {
  documentType: TradingOfferDocumentRequestType;
  description?: string;
  deadlineBusinessDays?: number;
  targetRole?: 'BUYER' | 'SELLER' | 'BOTH';
  requestedAt?: Date | string;
};

export type TradingOfferOperationParticipantAudit = {
  serverCapturedAt?: Date | string;
  clientIp?: string;
  forwardedFor?: string;
  requestUserAgent?: string;
  clientContext?: Record<string, unknown>;
};

export type TradingOfferOperation = {
  _id: string;
  society: string;
  tradingOffer: string | Partial<TradingOffer>;
  buyer: string | Partial<Partner>;
  seller: string | Partial<Partner>;
  shareClass: string | Partial<HoldingClass>;
  sharesCount: number;
  sharePrice: number;
  totalPrice: number;
  status: TradingOfferOperationStatus;
  requestDate: Date | string;
  completionDate?: Date | string;
  buyerDocuments: (string | { _id: string; name?: string })[];
  sellerDocuments: (string | { _id: string; name?: string })[];
  equityMarketPurchaseContract?: string | { _id: string; name?: string };
  comments: TradingOfferOperationComment[];
  statusHistory: TradingOfferOperationStatusHistory[];
  documentRequests?: TradingOfferOperationDocumentRequest[];
  createdAt: Date | string;
  updatedAt: Date | string;
  /** Buyer participation — same audit shape as offerPublisherAudit on TradingOffer */
  operationParticipantAudit?: TradingOfferOperationParticipantAudit;
};
